import { PolicyIssued } from 'scenes/common/types';
import { WirePolicyIssued } from '../types';

export const policyIssued: {
  [key in PolicyIssued]: WirePolicyIssued;
} = {
  [PolicyIssued.Business]: WirePolicyIssued.Business,
  [PolicyIssued.Person]: WirePolicyIssued.Personal,
  [PolicyIssued.Unspecified]: WirePolicyIssued.Unspecified,
};
